import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import type { CountyAggregate, ValkrtsAggregate } from './types';

interface State {
  valkretsar: ValkrtsAggregate[];
  countyAggregates: CountyAggregate[];
  loaded: boolean;
}

export function usePerRegionAggregates(): State {
  const [valkretsar, setValkretsar] = useState<ValkrtsAggregate[]>([]);
  const [countyAggregates, setCountyAggregates] = useState<CountyAggregate[]>([]);
  const [valkretsarLoaded, setValkretsarLoaded] = useState(false);
  const [countiesLoaded, setCountiesLoaded] = useState(false);

  useEffect(() => {
    return onSnapshot(
      collection(db, 'valkretsar'),
      snap => {
        setValkretsar(snap.docs.map(d => d.data() as ValkrtsAggregate));
        setValkretsarLoaded(true);
      },
      err => console.warn('valkretsar snapshot error:', err),
    );
  }, []);

  useEffect(() => {
    return onSnapshot(
      collection(db, 'counties'),
      snap => {
        setCountyAggregates(snap.docs.map(d => d.data() as CountyAggregate));
        setCountiesLoaded(true);
      },
      err => console.warn('counties snapshot error:', err),
    );
  }, []);

  return { valkretsar, countyAggregates, loaded: valkretsarLoaded && countiesLoaded };
}
